import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ProfileForm from './ProfileForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import {getVerify, updateAvatar, updateProfile} from "../redux/actions";


class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: this.props.currentUser.avatar,
            verifySent: false
        }
    }

    componentDidMount() {
        document.title = "Addiction | Profile";
    }

    handleDrop = dropped => {
        this.setState({ image: dropped[0] })
    };
    saveAvatar = () => {
        if (this.editor) {
            this.props.saveAvatar(this.state.image, this.editor.getCroppingRect())
        }

    };

    sendVerificationEmail = () => {
        this.setState({verifySent: true});
        this.props.getVerify()
    };

    sanitizeProfile = (values) => {
        let payload = null;
        if (values.displayName && values.displayName !== this.props.currentUser.displayName) {
            payload = {
                ...payload,
                displayName: values.displayName
            }
        }
        if (values.email && values.email !== this.props.currentUser.email) {
            payload = {
                ...payload,
                email: values.email
            }
        }
        if (values.steamId && values.steamId !== this.props.currentUser.steamId) {
            payload = {
                ...payload,
                steamId: values.steamId
            }
        }
        if (values.discordId && values.discordId !== this.props.currentUser.discordId) {
            payload = {
                ...payload,
                discordId: values.discordId
            }
        }
        if (payload) {
            this.props.onSubmit(payload);
        }
    };

    setEditorRef = (editor) => this.editor = editor;

    render() {
        if (this.props.isAuthenticated) {
            return (
                <div>
                    <h1>Account Profile</h1>
                    
                    <div className="panel-adt">
                        <div className="adt-flex-container">
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faUser} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin: 0}}>Account Username: {this.props.currentUser.username}</p>
                            </div>
                        </div>
                    </div>
                    <div className="panel-adt">
                        <ProfileForm
                            onSubmit={this.sanitizeProfile}
                            pending={this.props.pending}
                            errors={this.props.errors}
                            user={this.props.currentUser}
                            initialValues={{
                                displayName: this.props.currentUser.displayName,
                                email: this.props.currentUser.email,
                                steamId: this.props.currentUser.steamId,
                                discordId: this.props.currentUser.discordId
                            }}
                            setEditorRef={this.setEditorRef}
                            dropzoneRef={this.dropzoneRef}
                            handleDrop={this.handleDrop}
                            image={this.state.image}
                            saveAvatar={this.saveAvatar}
                            verify={this.sendVerificationEmail}
                            verifySent={this.state.verifySent}
                        />
                    </div>
                    
                </div>
            )
        } else {
            return (
                <Redirect to="/login" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    currentUser: state.auth.currentUser,
    errors: state.auth.error,
    isAuthenticated: state.auth.loggedIn,
    pending: state.auth.pending,
});

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (values) => dispatch(updateProfile(values)),
    saveAvatar: (avatar, crop) => dispatch(updateAvatar(avatar, crop)),
    getVerify: () => dispatch(getVerify()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/Auth/Profile.js